import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import * as S from './style';
import mainBanner1 from '@/assets/img/banner/member.jpg';
import TabList from '@/components/common/Tab/TabList/TabList';
import { useEffect, useState } from 'react';
import MembershipGuide from '@/components/Membership/MembershipGuide/MembershipGuide';
import MembershipFee from '@/components/Membership/MembershipFee/MembershipFee';
import MembershipPayment from '@/components/Membership/MembershipPayment/MembershipPayment';
import { useModalStore } from '@/store/modalStore';
import { useSignUpStore } from '@/components/SignUp/SignUpContext/SignUpContext';
import { useTokenStore } from '@/store/tokenStore';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';

import CompleteModal from '@/components/common/Modal/CompleteModal/CompleteModal';

const Memebership = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const { setStep } = useSignUpStore();
	const { showModal } = useModalStore();
	const { isLogin } = useTokenStore();
	const [searchParams] = useSearchParams();
	const [isOpen, setIsOpen] = useState(false);
	const params = location.state?.menu ?? '회원가입 안내';
	const sucessParams = searchParams.get('sucess') ?? '';
	const failParams = searchParams.get('aid') ?? '';

	const handleSetMenu = (menu: string) => {
		if (menu === '회원가입') {
			if (isLogin()) {
				showModal('이미 노화학회 회원이십니다.', 'confirm');
				return;
			} else {
				navigate('/auth/signup');
				return;
			}
		}
		if (menu === '연회비 납부') {
			if (!isLogin()) {
				showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
				return;
			}
		}
		navigate('/membership', { state: { menu: menu } });
	};

	useEffect(() => {
		if (params === '회원가입') {
			setStep('회원약관 동의');
		}

		if (sucessParams === 'true') {
			setIsOpen(true);
		}
		if (sucessParams === 'false' || failParams !== '') {
			showModal('결제에 실패했습니다. \n다시 시도해 주세요.');
			navigate('/membership', { state: { menu: '연회비 납부' } });
			return;
		}
	}, [params, sucessParams, failParams]);

	return (
		<main>
			<SubBanner subTitle="Membership" title="회원안내" img={mainBanner1} />

			<TabList menuList={['회원가입 안내', '회원가입', '회비안내', '연회비 납부']} menuKey={params} onListClick={handleSetMenu} />
			<S.Container>
				{params === '회원가입 안내' && <MembershipGuide />}
				{params === '회비안내' && <MembershipFee />}
				{params === '연회비 납부' && <MembershipPayment />}
			</S.Container>
			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<CompleteModal closeModal={setIsOpen} />
					</ModalBox>
				</ModalPortal>
			)}
		</main>
	);
};

export default Memebership;
